
import { useState, useEffect } from 'react';
import Button from '../../../components/base/Button';

export default function MembershipRequirements() {
  const [applicationsToday, setApplicationsToday] = useState(23);
  const [spotsRemaining, setSpotsRemaining] = useState(47);

  useEffect(() => {
    // Simulate real-time application counter
    const interval = setInterval(() => {
      if (Math.random() > 0.6) {
        setApplicationsToday(prev => {
          const newCount = prev + 1;
          // Occasionally decrease spots when applications increase
          if (Math.random() > 0.8) {
            setSpotsRemaining(current => Math.max(35, current - 1));
          }
          return newCount;
        });
      }
    }, 25000); // Update every 25 seconds

    return () => clearInterval(interval);
  }, []);

  // Reset daily counter at midnight (simulated)
  useEffect(() => {
    const resetDaily = () => {
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      
      const msUntilMidnight = tomorrow.getTime() - now.getTime();
      
      setTimeout(() => {
        setApplicationsToday(Math.floor(Math.random() * 15) + 8); // Reset to 8-22
      }, msUntilMidnight);
    };

    resetDaily();
  }, []);

  const requirements = [
    {
      icon: 'ri-money-dollar-circle-line',
      text: 'Have $5,000+ liquid capital or verified investor status',
      color: 'from-green-400 to-emerald-400'
    },
    {
      icon: 'ri-rocket-line',
      text: 'Are actively seeking to acquire, partner, or launch an A.I. business',
      color: 'from-blue-400 to-cyan-400'
    },
    {
      icon: 'ri-shield-check-line',
      text: 'Agree to confidentiality and responsible use terms',
      color: 'from-purple-400 to-pink-400'
    }
  ];

  return (
    <section className="py-32 relative">
      <div className="max-w-6xl mx-auto px-6">
        {/* Background Elements */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-64 h-64 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-80 h-80 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full blur-3xl"></div>
        </div>

        <div className="relative z-10">
          {/* Urgency Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center space-x-3 bg-red-500/20 border border-red-400/30 rounded-full px-6 py-3 mb-6">
              <div className="w-2 h-2 bg-red-400 rounded-full animate-pulse"></div>
              <span className="text-red-300 font-medium">{applicationsToday} applications submitted today</span>
            </div>
          </div>

          {/* Section Header */}
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-light tracking-tight mb-6">
              We Only Accept{' '}
              <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent font-medium">
                Qualified Members.
              </span>
            </h2>
            <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
              To protect exclusivity and ensure real deal flow, access is limited to those who:
            </p>
          </div>

          {/* Requirements */}
          <div className="space-y-8 mb-16">
            {requirements.map((req, index) => (
              <div key={index} className="group">
                <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300 group-hover:scale-105 cursor-pointer">
                  <div className="flex items-start space-x-6">
                    {/* Icon */}
                    <div className={`w-16 h-16 bg-gradient-to-br ${req.color} rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                      <i className={`${req.icon} text-2xl text-white`}></i>
                    </div>
                    
                    {/* Text */}
                    <div className="flex-1 pt-3">
                      <p className="text-lg text-gray-300 leading-relaxed">{req.text}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Final CTA with Scarcity */}
          <div className="text-center">
            <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 max-w-2xl mx-auto">
              <div className="mb-6">
                <div className="text-3xl font-bold text-yellow-400 mb-2">{spotsRemaining}</div>
                <p className="text-gray-300">Spots remaining this month</p>
              </div>
              
              <Button variant="primary" size="lg" className="whitespace-nowrap cursor-pointer mb-6 w-full">
                🚀 Apply Now - Get Priority Review
              </Button>
              
              {/* Urgency Text */}
              <div className="space-y-2 text-sm text-gray-400">
                <p>⚡ Applications reviewed within 24 hours</p>
                <p>🎯 Next cohort starts Monday</p>
                <p>🔒 Access is free for approved users</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
